import axios from 'axios';

const DEFAULT_API_URL = process.env.REACT_APP_API_URL || '/api/v1';

function getApiUrl() {
  return DEFAULT_API_URL;
}

export function clearAuth() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('mobile_environment');
  localStorage.removeItem('mobile_api_url');
}

// Сбрасываем устаревший переключатель контура, если пользователь ранее его использовал
localStorage.removeItem('mobile_environment');
localStorage.removeItem('mobile_api_url');

const api = axios.create({
  baseURL: getApiUrl(),
});

api.interceptors.request.use((config) => {
  config.baseURL = getApiUrl();
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (config.data && !(config.data instanceof FormData)) {
    config.headers['Content-Type'] = 'application/json';
  }
  return config;
});

export default api;

export const authApi = {
  login: (username, password) => api.post('/auth/login', { username, password }),
};

export const mobileApi = {
  tasks: (expertId, date) => api.get('/mobile/tasks', { params: { expert_id: expertId, date } }),
  goszadanie: () => api.get('/mobile/goszadanie'),
  dispatchCards: (date) => api.get('/mobile/dispatch-cards', { params: { date_str: date } }),
  dispatchCard: (cardId) => api.get(`/mobile/dispatch-cards/${cardId}`),
  confirmDispatchMembers: (cardId, members) => api.post(`/mobile/dispatch-cards/${cardId}/confirm`, { members }),
  departOffice: (cardId, data) => api.post(`/mobile/dispatch-cards/${cardId}/depart-office`, data),
  arriveObject: (cardId, data) => api.post(`/mobile/dispatch-cards/${cardId}/arrive-object`, data),
  departObject: (cardId, data) => api.post(`/mobile/dispatch-cards/${cardId}/depart-object`, data),
  arriveOffice: (cardId, data) => api.post(`/mobile/dispatch-cards/${cardId}/arrive-office`, data),
  saveChecklist: (cardId, data) => api.post(`/mobile/dispatch-cards/${cardId}/checklist`, data),
  saveWorks: (cardId, works) => api.post(`/mobile/dispatch-cards/${cardId}/works`, { works }),
  addWork: (cardId, data) => api.post(`/mobile/dispatch-cards/${cardId}/works/add`, data),
  removeWork: (cardId, data) => api.post(`/mobile/dispatch-cards/${cardId}/works/remove`, data),
  workCodes: () => api.get('/mobile/work-codes'),
  goszadanieGoTasks: () => api.get('/mobile/goszadanie-go/tasks'),
  goszadanieGoTask: (taskId) => api.get(`/mobile/goszadanie-go/tasks/${taskId}`),
  goszadanieGoChecklists: () => api.get('/mobile/goszadanie-go/checklists'),
  goszadanieGoEquipment: (q) =>
    api.get('/mobile/goszadanie-go/equipment', { params: { q } }),
  goszadanieGoSaveGeneral: (taskId, data) => api.patch(`/mobile/goszadanie-go/tasks/${taskId}/general`, data),
  goszadanieGoSaveCode: (taskId, index, data) => api.put(`/mobile/goszadanie-go/tasks/${taskId}/codes/${index}`, data),
  goszadanieGoComplete: (taskId) => api.post(`/mobile/goszadanie-go/tasks/${taskId}/complete`),
  goszadanieGoUploadPhotos: (taskId, index, formData) =>
    api.post(`/mobile/goszadanie-go/tasks/${taskId}/codes/${index}/photos`, formData),
  goszadanieGoDeletePhoto: (taskId, index, url) =>
    api.delete(`/mobile/goszadanie-go/tasks/${taskId}/codes/${index}/photos`, { data: { url } }),
  goszadanieGoProtocol: (taskId, index) =>
    api.get(`/mobile/goszadanie-go/tasks/${taskId}/codes/${index}/protocol`, { responseType: 'blob' }),
  goszadanieGoWorkCodes: () => api.get('/mobile/goszadanie-go/work-codes'),
  goszadanieGoCancelReasons: () => api.get('/mobile/goszadanie-go/cancel-reasons'),
  goszadanieGoCancelCode: (taskId, index, reason) =>
    api.post(`/mobile/goszadanie-go/tasks/${taskId}/codes/${index}/cancel`, { reason }),
  goszadanieGoAddCode: (taskId, code) =>
    api.post(`/mobile/goszadanie-go/tasks/${taskId}/codes`, { code }),
  goszadanieGoDispatch: (taskId) => api.get(`/mobile/goszadanie-go/tasks/${taskId}/dispatch`),
  goszadanieGoDispatchConfirm: (taskId, members) =>
    api.post(`/mobile/goszadanie-go/tasks/${taskId}/dispatch/confirm`, { members }),
  goszadanieGoDispatchGeo: (taskId, action, data) =>
    api.post(`/mobile/goszadanie-go/tasks/${taskId}/dispatch/${action}`, data),
  goszadanieGoDispatchChecklist: (taskId, data) =>
    api.post(`/mobile/goszadanie-go/tasks/${taskId}/dispatch/checklist`, data),
  startTask: (taskId, data) => api.post(`/mobile/tasks/${taskId}/start`, data),
  uploadPhoto: (taskId, formData) => api.post(`/mobile/tasks/${taskId}/photo`, formData),
  submitProtocol: (data) => api.post('/mobile/protocols', data),
  syncStatus: (expertId) => api.get('/mobile/sync/status', { params: { expert_id: expertId } }),
};

export const photoFixationApi = {
  searchObjects: (q, limit = 50, includeTodayPlan = false) =>
    api.get('/mobile/photo-fixation/objects', { params: { q, limit, include_today_plan: includeTodayPlan } }),
  createObject: (data) => api.post('/mobile/photo-fixation/objects', data),
  uploadPhotos: (objectId, shootingDate, files, gps = null) => {
    const formData = new FormData();
    formData.append('object_id', objectId);
    formData.append('shooting_date', shootingDate);
    if (gps && gps.lat != null && gps.lon != null) {
      formData.append('gps_lat', gps.lat);
      formData.append('gps_lon', gps.lon);
    }
    files.forEach((file) => formData.append('files', file));
    return api.post('/mobile/photo-fixation/photos', formData);
  },
  getPhotos: (objectId) =>
    api.get('/mobile/photo-fixation/photos', { params: { object_id: objectId } }),
  getMyPhotos: () => api.get('/mobile/photo-fixation/my-photos'),
};

export const zavhozApi = {
  create: (formData) => api.post('/zavhoz-requests', formData),
  myList: () => api.get('/zavhoz-requests'),
  detail: (id) => api.get(`/zavhoz-requests/${id}`),
  confirm: (id) => api.post(`/zavhoz-requests/${id}/confirm`),
  returnRequest: (id, comment) => api.post(`/zavhoz-requests/${id}/return`, { comment }),
  cancel: (id) => api.post(`/zavhoz-requests/${id}/cancel`),
  addComment: (id, text) => api.post(`/zavhoz-requests/${id}/comments`, { text }),
};

export const satisfactionApi = {
  session: () => api.get('/mobile/satisfaction/session'),
  send: (sessionId, text) => api.post(`/mobile/satisfaction/session/${sessionId}/messages`, { text }),
  finish: (sessionId) => api.post(`/mobile/satisfaction/session/${sessionId}/finish`),
};
